import React, { useState } from "react";
import * as moment from "moment";
import UserDefaultAvatar from "assets/img/user.svg";
import LazyLoadImage from "components/LazyLoadImage";
import ConvertSvgToComponent from "components/ConvertSvgToComponent";

function PostHeader({ post }) {
  const [timeDifference] = useState(moment(post.created_at).fromNow());
  const [postCreatedMessage] = useState({
    status: "Created a status",
    celebration: "Posted a Wall of Fame",
    brightidea: "Shared an Idea/Accouncement",
    topic: "Posted a new topic",
    slideshow: "Published a Slide Show",
    teamvideo: "Published a Team Video",
    poll: "Created a Poll",
    "todo-list": "Created a List",
    "todo-list-item": "Created a Todo List Item",
    coursecreation: "Created a Course"
  });
  const [postEngagedMessage] = useState({
    status: "Engaged on a status",
    celebration: "Engaged on a Wall of Fame",
    brightidea: "Engaged on an Idea/Accouncement",
    topic: "Engaged on a topic",
    slideshow: "Engaged on a Slide Show",
    teamvideo: "Engaged on a Team Video",
    poll: "Engaged on a Poll",
    "todo-list": "Engaged on a List",
    "todo-list-item": "Engaged on a Todo List Item",
    coursecreation: "Engaged on a Course"
  });
  const postDescription =
    post?.content_type_id === 1
      ? postCreatedMessage[post?.type]
      : postEngagedMessage[post?.type];

  return (
    <div className="post-header">
      <div className="img_user">
        <span>
          <LazyLoadImage
            style={{ cursor: "pointer" }}
            imageClassName="userAvatar"
            image={post?.user?.avatar ?? UserDefaultAvatar}
            key={`${post?.user?.full_name || post?.user?.name}`}
            alt={`${post?.user?.full_name || post?.user?.name}`}
          />
        </span>
        <div className="userInformation">
          <span className="post_uname">{post?.user?.full_name || post?.user?.name}</span>
          <span>{postDescription}</span>
          <span className="searchteamName">{post?.team?.name}</span>
          <span className="post_time">Posted {timeDifference}</span>
        </div>
      </div>
      {post?.type !== "text" && (
        <div className="p-h-right">
          <ConvertSvgToComponent
            icon={post?.type}
            color={"white"}
            imageclass="postClass"
          />
        </div>
      )}
    </div>
  );
}

export default PostHeader;
